const SAVE_CUSTOMER_KYC = 'SaveKycDetails'
const NEW_KYC_TITLE = "Confirm Details"
const GO_BACK = ' Go Back';
const NO = 'No'; 
const SUBMIT = 'SUBMIT';
const YES = 'Yes';
const CONTINUE = "Continue";
const DONE = "Okay";

export {
    SAVE_CUSTOMER_KYC,
    NEW_KYC_TITLE,
    GO_BACK,
    NO,
    SUBMIT,
    YES,
    CONTINUE,
    DONE
};
